import {
  fetchGetStateByStateKey,
  fetchPutState,
} from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

import { StepType } from './Steps';
import { useGetStateQuery } from './StepValidator';
import { useStateKey } from '../../../hooks/useStateKey.hook';
import { denormaliseStepData, normaliseStepData } from '../stateNormalisation';

export function useStepData<S extends StepType>(stepId: S) {
  const { stateKey } = useStateKey();
  const { data: stepData, refetch: refetchStepData } = useGetStateQuery(
    (data) => normaliseStepData(data)[stepId],
  );

  const denormaliser = denormaliseStepData(stepId);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (data: ReturnType<typeof normaliseStepData>[S]) => {
      if (!stateKey) {
        throw new Error('No statekey provided');
      }

      const freshState = await fetchGetStateByStateKey({ stateKey });
      // @ts-expect-error
      const state = denormaliser(freshState, data)!;
      return fetchPutState({ stateKey, body: state });
    },
    onSuccess: async () => {
      await refetchStepData();
    },
  });

  const updateStepData = (data: ReturnType<typeof normaliseStepData>[S]) => {
    return mutateAsync(data);
  };

  return {
    stepData,
    updateStepData,
    refetchStepData,
    isUpdatingStepData: isPending,
  };
}
